import { render, staticRenderFns } from "./iconCard.vue?vue&type=template&id=0f6c8d82&scoped=true"
import script from "./iconCard.vue?vue&type=script&lang=js"
export * from "./iconCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6c8d82",
  null
  
)

export default component.exports